import * as d3 from 'd3-selection';

/**
 A D3 legend component. Uses HTML instead of SVG for better control over text
 flow and layout.
 */
function chartLegend(selection, colorAccessor) {
  const item = selection
    .selectAll('.legend-item')
    .data((d) => d);
  item.exit().remove();
  item.enter()
    .append('li')
    .attr('class', 'legend-item')
    .merge(item)
    .each(function legendItem(k, i) {
      let key;
      let label;
      if (k instanceof Array) {
        [key, label] = k;
      } else {
        key = k;
        label = k;
      }
      const color = d3.select(this)
        .selectAll('.color')
        .data([colorAccessor(key, i)]);
      color.enter()
        .append('span')
        .attr('class', 'color')
        .merge(color)
        .style('background-color', (d) => d);
      const text = d3.select(this)
        .selectAll('.label')
        .data([label]);
      text.enter()
        .append('span')
        .attr('class', 'label')
        .merge(text)
        .text((d) => d);
    });
}


export default chartLegend;
